/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDUturnRightUpIcon64Regular = forwardRef('ArrowDUturnRightUpIcon64Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 64 }, props),
        React.createElement("path", { d: "M60.618 28a1.5 1.5 0 1 1-2.236 2L44.363 14.332a2.518 2.518 0 0 0-.363-.334V35.5C44 46.27 35.27 55 24.5 55S5 46.27 5 35.5v-15a1.5 1.5 0 0 1 3 0v15C8 44.613 15.387 52 24.5 52S41 44.613 41 35.5V13.998c-.13.097-.25.209-.363.334L26.617 30a1.5 1.5 0 0 1-2.235-2l14.02-15.668a5.5 5.5 0 0 1 8.197 0L60.618 28Z" })));
});
